import React from 'react';
import GenericApprovalSection from './GenericApprovalSection';
import { ResourceRequest } from '../../hooks/incidentResourceRequestHooks';
import { ApprovalStage } from '../utils/ResourceRequestTypes';

interface SectionChiefApprovalSectionProps {
  requestData: ResourceRequest | null;
  currentStage: ApprovalStage;
  onApprove: () => void;
  isSubmitting: boolean;
  isCompleted: boolean;
}

const SectionChiefApprovalSection: React.FC<
  SectionChiefApprovalSectionProps
> = ({ requestData, currentStage, onApprove, isSubmitting, isCompleted }) => {
  return (
    <GenericApprovalSection
      stage="section_chief"
      requestData={requestData}
      currentStage={currentStage}
      onApprove={onApprove}
      isSubmitting={isSubmitting}
      isCompleted={isCompleted}
      nameField="section_chief_name"
      positionField="section_chief_position"
      commentsField="section_chief_comments"
      signatureField="section_chief_signature"
      timestampField="section_chief_signature_timestamp"
    />
  );
};

export default SectionChiefApprovalSection;
